import React, { useContext, useEffect, useState } from "react"

import { Color } from "~tailwindui/types/enums"

import { Button } from "~tailwindui/Basics"
import Modal from "~tailwindui/Modal"

import EventEmitter from "src/EventEmitter"
import airbrake from "src/airbrake-notifier"
import emptyFunction from "src/emptyFunction"

import CloudroomContext from "components/ChimeCloudroom/CloudroomContext"

const ScreenShareRequestedModal = () => {
  const { channel } = useContext(CloudroomContext)

  const [screenShareRequestedBy, setScreenShareRequestedBy] = useState<{
    userId: string
    name: string
  }>()

  useEffect(() => {
    const onScreenShareRequest = data => setScreenShareRequestedBy(data)
    EventEmitter.subscribe("screen_share_request", onScreenShareRequest)

    return () =>
      EventEmitter.unsubscribe("screen_share_request", onScreenShareRequest)
  }, [])

  const approveRequest = () => {
    if (!screenShareRequestedBy.userId) {
      airbrake.notify({
        error: "Not submitting screen share response, no userId is present",
        name: "ChimeCloudRoom/Tutor",
        params: { screenShareRequestedBy },
      })
    } else {
      channel.perform("screen_share_response", {
        approved: true,
        userId: screenShareRequestedBy.userId,
      })
    }
    setScreenShareRequestedBy(undefined)
  }

  const denyRequest = () => {
    channel.perform("screen_share_response", {
      approved: false,
      userId: screenShareRequestedBy.userId,
    })
    setScreenShareRequestedBy(undefined)
  }

  return (
    <Modal.Dialog
      hideButton
      isOpen={!!screenShareRequestedBy?.userId}
      closeModal={emptyFunction}
    >
      <>
        <Modal.Header hideCloseButton>Screen Share Request</Modal.Header>
        <Modal.Body>
          {screenShareRequestedBy?.name} has requested to share their screen
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-end space-x-2">
            <Button onClick={approveRequest}>Allow</Button>
            <Button color={Color.Red} onClick={denyRequest}>
              Reject
            </Button>
          </div>
        </Modal.Footer>
      </>
    </Modal.Dialog>
  )
}

export default ScreenShareRequestedModal
